import React from "react";
import Order from "./Orders/order";

const ManageOrders = () => {
  return (
    <>
      <Order isLoading={true} />
    </>
  );
};

export default ManageOrders;
